module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img53.d3d305d0.jpg";